import * as React from 'react'
import { observer } from 'mobx-react'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import ContentError from 'components/ContentError'
import type InfiniteScrollProvider from 'utils/InfiniteScrollProvider'

export type OnClickItemRow<S> = (item: S) => any

export type VirtuosoContext<S> = {
  scroller: InfiniteScrollProvider<S, any>
  onClickItemRow?: OnClickItemRow<S>
}

interface VirtualTableInfiniteScrollLoaderProps<S> {
  context?: VirtuosoContext<S>
}

/**
 * Table Infinite Scroll Loader. Created by the TableVirtuoso component.
 */
export default observer(
  React.forwardRef(function VirtualTableInfiniteScrollLoader<S>(
    { context }: VirtualTableInfiniteScrollLoaderProps<S>,
    ref: React.Ref<any>,
  ) {
    const scroller = context?.scroller
    if (!scroller) {
      // The typing in Virtuoso says it can be undefined, but we know that we
      // pass it in.
      return null
    }

    return (
      <tfoot ref={ref}>
        <tr>
          {/* The error/loading state wants to span the entire table */}
          <td colSpan={100}>
            {scroller.fetch.error ? (
              <ContentError error={scroller.fetch.error} />
            ) : !scroller.isDone ? (
              <InfiniteScrollLoader scrollProvider={scroller} />
            ) : null}
          </td>
        </tr>
      </tfoot>
    )
  }),
)
